var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Shape } from 'lincd/shapes/Shape';
import { linkedShape } from '../package.js';
import { objectProperty } from 'lincd/shapes/SHACL';
import { lincdForm } from '../ontologies/lincd-form.js';
import { InputField } from './InputField.js';
import { ShapeSet } from 'lincd/collections/ShapeSet';
let Form = class Form extends Shape {
    get targetTypes() {
        return InputField.getSetOf(this.getAll(lincdForm.targetType));
    }
};
/**
 * indicates that instances of this shape need to have this rdf.type
 */
Form.targetClass = lincdForm.Form;
__decorate([
    objectProperty({
        path: lincdForm.targetType,
    }),
    __metadata("design:type", ShapeSet),
    __metadata("design:paramtypes", [])
], Form.prototype, "targetTypes", null);
Form = __decorate([
    linkedShape
], Form);
export { Form };
//# sourceMappingURL=Form.js.map